import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  TGetCheckCorrectionRequest,
  TGetCheckCorrectionResponse,
} from "./checkCorrections.schema";

export const getCheckCorrection =
  (axios: IAxiosInstance) =>
  async ({ correctionID, test }: TGetCheckCorrectionRequest) => {
    try {
      const response = await axios.noRetry.get<TGetCheckCorrectionResponse>(
        `/api/checkCorrections/${encodeURIComponent(correctionID)}`,
        { params: { test } }
      );
      const resData = response.data;

      if (resData.success) {
        return resData.data;
      }
      throw new Error("Something went wrong");
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
